import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  chartTitle: { flexGrow: 1 },
  chartToolbar: { padding: 0, marginBottom: 20 },
  chartWrapper: {
    height: "100%",
  },
}));
